AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "ActiveQuests");

AoPS.Alcumus.Views.ActiveQuests = (function (AlcVActiveQuests) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Modal = AoPS.Ui.Modal;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	// Optional and allowed to load before or after this file
	// AoPS.Alcumus.Debug;

	//
	// Quest badge animation functions
	//

	function makeCompleteMaskEl() {
		return $(
			$.parseHTML(
				'<div class="alc-center-pin"><img alt="Mask" src="/alcumus/images/green_quest_mask.png"></div>'
			)
		);
	}

	// In all of the below, main is an .alc-center-pin jquery element with the main
	// badge, and the callback is called at the end without arguments.
	// (When originally written, quest badges were not sprited and could be scaled.
	// This is not the case anymore, so main must remain unscaled.)

	function doAssignAnimation(main, callback) {
		main.css("opacity", 0);
		main.animate(
			{
				opacity: 1,
			},
			{
				duration: 1000,
				easing: "linear",
				queue: false,
				complete: callback,
			}
		);
	}

	function doFailAnimation(main, callback) {
		main.animate(
			{
				opacity: 0,
			},
			{
				duration: 1000,
				easing: "linear",
				queue: false,
				complete: callback,
			}
		);
	}

	function doCompleteAnimation(main, callback) {
		var larger = "120%";
		var mask = makeCompleteMaskEl().css("z-index", 10000);
		var back_mask = makeCompleteMaskEl();
		main.after(mask).after(back_mask).css("z-index", 1);

		var finish = function () {
			mask.remove();
			back_mask.remove();
			callback();
		};

		back_mask.css({
			width: larger,
			height: larger,
		});

		mask.css({
			opacity: 0,
			width: larger,
			height: larger,
		});

		mask.animate(
			{
				opacity: 1,
			},
			{
				duration: 550,
				easing: "linear",
				queue: false,
			}
		);

		setTimeout(function () {
			mask.animate(
				{
					opacity: 0,
				},
				{
					duration: 550,
					easing: "linear",
					queue: false,
				}
			);
		}, 650);

		setTimeout(function () {
			mask.animate(
				{
					opacity: 1,
				},
				{
					duration: 550,
					easing: "linear",
					queue: false,
				}
			);
		}, 1300);

		setTimeout(function () {
			main.hide();
			back_mask.hide();

			mask.animate(
				{
					opacity: 0,
				},
				{
					duration: 550,
					easing: "linear",
					queue: false,
					complete: finish,
				}
			);
		}, 1950);
	}

	//
	// Views
	//

	AlcVActiveQuests.MainPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-quests-active-panel");

			this.aops_panel = !!options.aops_panel;
			this.active_quest_views = [];
			this.has_been_rendered = false;

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.listenTo(
					this.model.get("quests"),
					"quests_loaded",
					this.updateQuests
				);
				this.updateQuests();
			}, this);
			this.renderLoading();
		},

		// Entry method for updating the quest panel
		updateQuests: function () {
			var new_quests = this.getNewQuests(
				this.model.getActiveQuestsCollection(),
				this.active_quest_views
			);
			if (new_quests.no_changes) {
				return;
			}

			if (!this.has_been_rendered) {
				new_quests.assign = [];
			}
			this.has_been_rendered = true;

			var readyForNewQuests = _.bind(function () {
				this.replaceSubviews(new_quests.show, new_quests.assign);
				this.render();
			}, this);

			if (new_quests.fail.length || new_quests.complete.length) {
				this.animateFinished(
					new_quests.fail,
					new_quests.complete,
					readyForNewQuests
				);
			} else {
				readyForNewQuests();
			}
		},

		// Returns an object with keys:
		//   no_change : true if the new IDs to display are the same as the old.
		//   show : the array of quest IDs to show after all animations are done.
		//   assign : an array of quest IDs that are newly assigned.
		//   fail : an array of subviews for quests that were just failed.
		//   complete : an array of subviews for quests that were just completed.
		getNewQuests: function (quests_coll, before_views) {
			var now_ids = quests_coll.pluck("id");

			// Figure out which quests were just failed or completed, and grab
			// all current quest IDs while we're at it.
			var fail = [];
			var complete = [];
			var before_ids = [];

			_.each(before_views, function (view) {
				var model = view.model;
				var quest_id = model.get("quest").id;
				before_ids.push(quest_id);

				if (_.indexOf(now_ids, quest_id) >= 0) {
					// Still active; skip the other branches
				} else if (model.get("is_failed")) {
					fail.push(view);
				} else if (model.get("is_completed")) {
					complete.push(view);
				}
			});

			var int_ids = _.intersection(now_ids, before_ids);
			return {
				no_change: now_ids.length === int_ids.length,
				show: now_ids,
				assign: _.difference(now_ids, before_ids),
				fail: fail,
				complete: complete,
			};
		},

		animateFinished: function (fail_views, complete_views, callback) {
			var animating = 0;
			var onAnimDone = function (view) {
				this.stopListening(view);
				animating -= 1;
				if (animating === 0 && callback) {
					callback();
				}
			};

			_.each(
				fail_views,
				function (view) {
					animating += 1;
					this.listenTo(view, "animation_done", onAnimDone);
					view.startAnimation("fail");
				},
				this
			);

			_.each(
				complete_views,
				function (view) {
					animating += 1;
					this.listenTo(view, "animation_done", onAnimDone);
					view.startAnimation("complete");
				},
				this
			);
		},

		replaceSubviews: function (quest_ids, assigned_ids) {
			var quests = this.model.get("quests");

			this.clearLocation("@active_quests");

			this.active_quest_views = quest_ids.map(function (quest_id) {
				var model = quests.get(quest_id);
				var level_model = model && model.getAssigned();
				if (!level_model) {
					return;
				}

				var view_obj = new AlcVActiveQuests.Badge({
					model: level_model,
				});
				this.addSubviewToLocation(view_obj, "@active_quests");

				if (_.indexOf(assigned_ids, quest_id) >= 0) {
					view_obj.startAnimation("assign");
				}
				return view_obj;
			}, this);
		},

		getContext: function () {
			return {
				quests_empty: !this.model.getActiveQuestsCollection().length,
			};
		},

		postRender: function () {
			// Done here instead of template since top element is normally untouched
			// after the first render.
			if (this.aops_panel) {
				this.$el.removeClass("white-panel").addClass("aops-panel");
			}

			// Preload the animation masks
			// this.$el.append(makeFailMaskEl().hide());
			this.$el.append(makeCompleteMaskEl().hide());

			var AlcDebug = AoPS.Alcumus.Debug;
			if (AlcDebug) {
				this.debug_click_count = 0;
				this.$("h1").click(
					_.bind(function () {
						var view =
							this.active_quest_views[
								this.debug_click_count % this.active_quest_views.length
							];
						var anim = ["assign", "fail", "complete"][
							this.debug_click_count % 3
						];
						if (!view) {
							return;
						}
						view.startAnimation(anim);
						setTimeout(_.bind(view.resetDisplay, view), 3000);
						this.debug_click_count += 1;
					}, this)
				);
			}
		},
	});

	AlcVActiveQuests.Badge = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-quests-active-badge");

			this.listenTo(this.model, "change", this.render);
			this.render();
		},

		events: {
			mousemove: "onHoverOver",
			mousewheel: "onHoverLeave",
			mouseleave: "onHoverLeave",
			click: "onClick",
		},

		resetDisplay: function () {
			this.$(".alc-center-pin").first().show().css({
				opacity: "",
				width: "",
				height: "",
			});
		},

		// Helper function; should only be called internally. Use the startAnimation
		// method when outside this class.
		setCurrentAnimation: function (val) {
			var orig_animation = this.current_animation;

			if (val && orig_animation !== val) {
				this.$(".alc-custom-tooltip").hide();
				this.current_animation = val;
				orig_animation && this.trigger("animation_done", this, orig_animation);
			} else if (!val && orig_animation) {
				delete this.current_animation;
				this.trigger("animation_done", this, orig_animation);
			}
		},

		startAnimation: function (type) {
			var main = this.$(".alc-center-pin").first();
			var callback = _.bind(this.setCurrentAnimation, this, null);

			if (type === "assign") {
				this.setCurrentAnimation("assign");
				doAssignAnimation(main, callback);
			} else if (type === "fail") {
				this.setCurrentAnimation("fail");
				doFailAnimation(main, callback);
			} else if (type === "complete") {
				this.setCurrentAnimation("complete");
				doCompleteAnimation(main, callback);
			}
		},

		getContext: function () {
			var model = this.model;

			return {
				badge_data: model.getBadgeData(),
				name: model.get("name"),
				description: model.get("description"),
				progress: model.get("progress"),
			};
		},

		postRender: function () {
			this.$(".alc-custom-tooltip").hide();
		},

		onHoverOver: function () {
			if (this.current_animation) {
				return;
			}
			this.$(".alc-custom-tooltip").show();
		},

		onHoverLeave: function () {
			this.$(".alc-custom-tooltip").hide();
		},

		abandonQuest: function () {
			this.model.abandon(function (ok, data) {
				if (!ok) {
					AlcVBase.showModalError(
						"An error occurred when trying to abandon a quest.",
						data
					);
				}
			}, this);
		},

		onClick: function () {
			if (this.current_animation) {
				return;
			}

			var model = this.model;
			var user = model.get("user");
			var can_abandon =
				user.get("abandons_left_today") > 0 || user.get("is_admin");

			var buttons = [
				{text: "Abandon", value: "abandon"},
				{text: "Continue", value: "default"},
			];
			if (!can_abandon) {
				buttons = [{text: "OK", value: "default"}];
			}

			var modalTpl = compileTemplate("#alc-tpl-quests-active-modal");
			var modal_html = modalTpl({
				name: model.get("name"),
				description: model.get("description"),
				progress: model.get("progress"),
				badge_data: model.getBadgeData(),
				can_abandon: can_abandon,
				is_admin: user.get("is_admin"),
			});

			Modal.show({
				body: modal_html,
				type: "buttons",
				buttons: buttons,
				frame_class: "aops-modal-standard",
				onButtonClick: _.bind(function (value) {
					if (value === "abandon") {
						this.abandonQuest();
					}
				}, this),
			});
		},
	});

	return AlcVActiveQuests;
})(AoPS.Alcumus.Views.ActiveQuests);
